"use client";

import { Core } from "@faire/design-tokens";
import * as React from "react";
import styled, { useTheme } from "styled-components";

import { Chevron } from "../../../icons/foundation/Chevron";
import { Close } from "../../../icons/foundation/Close";
import { getSpacing } from "../../../spacing";

import { ModalNavigationProps } from "./ModalNavigationProps";

export const ModalNavigationAbsolute: React.FC<ModalNavigationProps> = ({
  onClose,
  onBack,
  onForward,
  primary,
  showCloseButton,
  closeIconProps,
  backIconProps,
  forwardIconProps,
}) => {
  const theme = useTheme();
  const modalTheme = theme.modals?.[primary ? "primary" : "default"];
  const iconColor = modalTheme?.color ?? Core.icon.default;
  const iconProps = modalTheme?.iconProps ?? {};
  return (
    <>
      {showCloseButton && onClose ? (
        <CloseButton
          className="closeButton"
          onClick={onClose}
          data-test-id="modalCloseButton"
          style={{ padding: getSpacing("2x") }}
        >
          <Close color={iconColor} {...iconProps} {...closeIconProps} />
        </CloseButton>
      ) : null}
      {onBack ? (
        <BackButton
          className="backButton"
          onClick={onBack}
          data-test-id="modalBackButton"
        >
          <Chevron
            direction="left"
            color={iconColor}
            {...iconProps}
            {...backIconProps}
          />
        </BackButton>
      ) : null}
      {onForward ? (
        <ForwardButton
          className="forwardButton"
          onClick={onForward}
          data-test-id="modalForwardButton"
        >
          <Chevron
            direction="right"
            color={iconColor}
            {...iconProps}
            {...forwardIconProps}
          />
        </ForwardButton>
      ) : null}
    </>
  );
};

/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/IconButton/IconButton#IconButton"
 */
const CloseButton = styled.button`
  background: transparent;
  border: 0;
  border-radius: 0;
  outline: 0;

  padding: 10px;
  padding-right: ${getSpacing("2x")};
  padding-top: ${getSpacing("2x")};

  cursor: pointer;

  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  &:focus-visible {
    outline: -webkit-focus-ring-color auto 1px;
    border-radius: 50px;
  }
`;

const BackButton = styled(CloseButton)`
  padding-right: 10px;
  padding-left: ${getSpacing("2x")};
  left: 0;
  right: unset;
`;

const ForwardButton = styled(CloseButton)`
  left: 64px;
`;
